import React, { useState, useEffect } from 'react';
import styles from './Coupon.scss';
import classNames from 'classnames/bind';
import { couponEndTime, countTime } from 'shared/utils/date';

const cx = classNames.bind(styles);

function Coupon({
  className,
  image,
  handleClick,
  handleClose,
  couponInfo,
  text,
}) {
  const [remainTime, setRemainTime] = useState('');

  useEffect(() => {
    //쿠폰 종료일 까지
    if (couponInfo.useEndType === 'COUPON_DATE') {
      setInterval(() => {
        setRemainTime(couponEndTime(couponInfo.viewEndDateAsString));
      }, 1000);
      //당일 자정까지
    } else if (couponInfo.useEndType === 'TODAY') {
      setInterval(() => {
        setRemainTime(countTime('day'));
      }, 1000);
      //익일 자정까지
    } else if (couponInfo.useEndType === 'TOMORROW') {
      setInterval(() => {
        setRemainTime(couponEndTime(couponInfo.viewEndDateAsString));
      }, 1000);
      //쿠폰 커스텀 까지
    } else {
      setInterval(() => {
        setRemainTime(couponEndTime(couponInfo.viewEndDateAsString));
      }, 1000);
    }
  }, []);

  return (
    <div className={cx(`Coupon`, className)}>
      <div className="bg">
        <img src={image} alt="bg" />
      </div>
      <div className="close" onClick={handleClose} />
      <div className="btn-wrap">
        {/* <p className="last-time">
          쿠폰 만료까지
          <span className="coupon-before-time">{` ${remainTime}`}</span>
        </p> */}
        <button className="btn" onClick={handleClick}>
          <span onClick={handleClick}>{text}</span>
        </button>
      </div>
    </div>
  );
}

export default Coupon;
